import { KEY_ACCESS_TOKEN } from './typings.d';
import { jwtDecode } from 'jwt-decode';

export function getJWTPayload() {
    const token = localStorage.getItem(KEY_ACCESS_TOKEN);

    if (token) {
        // 定义你的 Payload 结构
        type Payload = {
            exp: number;
            id: API.JWTPayload
            // ... 其他自定义字段
        }

        const decoded = jwtDecode<Payload>(token);
        // console.log(JSON.stringify(decoded));
        // console.log('用户ID:', decoded.id);
        // console.log('角色:', decoded.role);
        // console.log('角色:', decoded.name);

        // 检查是否过期
        const isExpired = decoded.exp * 1000 < Date.now();
        // console.log('是否过期:', isExpired);
        if (isExpired) {
            // 处理过期情况，例如清除 token 或跳转到登录页面
            localStorage.removeItem(KEY_ACCESS_TOKEN);
            return undefined;
        }
        return decoded.id;
    }
    return undefined;
}